/** Input types that never summon an on-screen keyboard. */
const NON_TEXT_INPUT_TYPES = [
  'button',
  'checkbox',
  'radio',
  'range',
  'file',
  'submit',
  'reset',
  'color',
  'hidden',
]

/** True when `el` is a text-entry element (would keep the soft keyboard up). */
export function isTextEntryElement(el: Element | EventTarget | null): boolean {
  if (el instanceof HTMLTextAreaElement) return true
  if (el instanceof HTMLInputElement) return !NON_TEXT_INPUT_TYPES.includes(el.type)
  if (el instanceof HTMLElement && el.isContentEditable) return true
  return false
}
